import getCookie from '../getCookie';

const getBrowserCookieId = (override?: string): string | null => {
  if (override !== undefined) {
    return override;
  }
  return getCookie('BrowserCookieId');
};

export default getBrowserCookieId;
